/**
 * @module pages/Schedule
 */
export { SchedulePage } from './SchedulePage.jsx';
